module.exports = __webpack_public_path__ + "static/media/savio29.c48dd07e.jpg";